import React from "react";

import InspectorGroup from "../../components/inspector/InspectorGroup";
import InspectorRow from "../../components/inspector/InspectorRow";
import Icon from "../../components/interface/Icon";

const renderNotAllowedBox = (boxTitle, boxLabel, itemLabel, onOpenSettingsClick) => {
  return (
    <InspectorGroup label={boxTitle}>
      <InspectorRow>
        <div className="groupUnavailable" onClick={onOpenSettingsClick}>
          <Icon icon="sidebarSettings" color="mid" />
          <span>
            {itemLabel} items cannot have {boxLabel}.
          </span>
        </div>
      </InspectorRow>
    </InspectorGroup>
  );
};

export default renderNotAllowedBox;
